<template>
  <NavItem :item="item" :custom-click-fn="openToolsModal" />
</template>

<script>
import NavItem from '@/modules/core/nav/components/NavItem.vue';
import { NavItem as NavItemClass } from '/@/modules/core/nav/models/NavItem';
import { ToolsModalFlowService } from '@/modules/admin/services/resource/ToolsModalFlowService';
import { HasAuthUserMixin } from '@/modules/core/app/mixins/HasAuthUserMixin';
import { AdvisorPortalToolsOpened } from '@/modules/financialadvisor/models/segmentevents/AdvisorPortalToolsOpened';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ToolsNavItem',
  mixins: [HasAuthUserMixin],
  components: { NavItem },
  props: {
    item: {
      type: NavItemClass,
      required: true
    }
  },
  methods: {
    openToolsModal() {
      if (this.authUser?.isInFinancialAdvisorProfessionGroup) {
        AdvisorPortalToolsOpened.dispatch();
      }

      ToolsModalFlowService.show(this);
    }
  }
};
</script>
